import React from 'react';
import { motion } from 'framer-motion';

export default function HowItWorks() {
  const steps = [
    {
      num: '01',
      title: 'Complete Intake',
      desc: 'Answer a few questions about your health and goals. It takes about 5 minutes.'
    },
    {
      num: '02',
      title: 'Meet Your Doctor',
      desc: 'A licensed doctor reviews your information and determines if treatment is right for you.'
    },
    {
      num: '03',
      title: 'Get Your Medication',
      desc: 'If approved, your medication ships free and arrives at your door in 2-3 business days.'
    }
  ];

  return (
    <section id="how-it-works" className="py-24 bg-white relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-20 max-w-2xl mx-auto">
          <h2 className="text-4xl md:text-5xl font-extrabold text-slate-900 tracking-tight mb-6">How it works</h2>
          <p className="text-xl text-slate-600 leading-relaxed">Getting started is simple and takes just a few minutes. We handle the rest.</p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 relative">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[10%] right-[10%] h-0.5 bg-gradient-to-r from-teal-100 via-teal-200 to-teal-100 z-0"></div>

          {steps.map((step, i) => (
            <motion.div 
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ delay: i * 0.2, duration: 0.6 }}
              className="relative z-10 group"
            >
              <div className="bg-white rounded-3xl p-8 premium-shadow border border-slate-100 h-full hover:-translate-y-2 transition-transform duration-300">
                <div className="w-16 h-16 bg-slate-900 text-white rounded-2xl flex items-center justify-center text-xl font-bold mb-8 group-hover:bg-teal-600 transition-colors shadow-lg shadow-slate-200">
                  {step.num}
                </div>
                <h3 className="text-2xl font-bold text-slate-900 mb-4">{step.title}</h3>
                <p className="text-slate-600 text-lg leading-relaxed">{step.desc}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}